import { Model } from '@models'
import SEND_MFA_SMS_CODE from '@screens/MfaChallenge/graphql/sendMfaSmsCode.ts'
import VERIFY_MFA_SMS_CODE from '@screens/MfaChallenge/graphql/verifyMfaSmsCode.ts'

export default class MfaChallenge {
  namespace = 'mfaChallenge'

  state = {
    ...Model.defaultState,
  }

  effects = {
    sendMfaSmsCode: Model.buildEffect({
      name: `${this.namespace}/sendMfaSmsCode`,
      query: SEND_MFA_SMS_CODE,
      dataPath: 'sendMfaSmsCode',
      isSuccess: (response: any) => response?.success,
    }),
    verifyMfaSmsCode: Model.buildEffect({
      name: `${this.namespace}/verifyMfaSmsCode`,
      query: VERIFY_MFA_SMS_CODE,
      dataPath: 'verifyMfaSmsCode',
    }),
  }

  reducers = { ...Model.defaultReducers }
}
